import type { QuoteDocument } from '@kalos/kalos-rpc';

export function getQuoteDocumentTaxRate(doc: QuoteDocument | null | undefined): number {
  const t = doc?.tax;
  return typeof t === 'number' && Number.isFinite(t) ? t : 0;
}

export function getQuoteDocumentTaxCost(doc: QuoteDocument | null | undefined): number {
  const t = doc?.taxCost;
  return typeof t === 'number' && Number.isFinite(t) ? t : 0;
}
